module.exports = __webpack_public_path__ + "img/icon_school.5f6e93de.svg";